module.exports = __webpack_public_path__ + "media/images/reports-icon-3470736e6e627e9ca4315855528a8ae9.svg";